import { combineReducers } from "redux";
import { authSlice } from "./auth.slice";
import siteDataReducer from "./siteDataSlice";
import userDataReducer from "./userDataSlice";
import crmReducer from "./crm.slice";

const rootReducer = combineReducers({
  siteData: siteDataReducer,
  users: userDataReducer,
  authData: authSlice.reducer,
  crm: crmReducer,
});

export default rootReducer;
